import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedContactsComponent } from './saved-contacts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes, Router } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { AppMaterialModule } from 'src/app/app-material.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { TableContactsComponent } from './components/table/table.component';
import { ContactDetailsComponent } from './modals/contact-details/contact-details.component';
import { AddContactComponent } from './modals/add-contact/add-contact.component';
import { RemoveContactConfirmComponent } from './modals/remove-contact-confirm/remove-contact-confirm.component';
import { MatPaginatorIntlBr } from 'src/app/shared/components/custom-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { ContactsMobileComponent } from './components/contacts-mobile/contacts-mobile.component';

const routes: Routes = [{ path: '', component: SavedContactsComponent }];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    AppMaterialModule,
    SharedComponentsModule,
  ],
  declarations: [
    SavedContactsComponent,
    TableContactsComponent,
    ContactDetailsComponent,
    AddContactComponent,
    RemoveContactConfirmComponent,
    ContactsMobileComponent,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: (router: Router) => {
        const paginator = new MatPaginatorIntlBr(router);
        paginator.setItemType('contatos');
        return paginator;
      },
      deps: [Router],
    },
  ],
})
export class SavedContactsModule {}
